export default __webpack_public_path__ + "static/media/under_midashi_pc@2x.0aa788b7.jpg";